export function getProps(props) {
    const {
        style,
        className,
        name,
        label,
        labelClassName,
        errorClassName,
        restrictRule,
        required,
        optional,
        disabled,
        controlProps,
        ...rest
    } = props;
    const row = {
        required,
        optional,
        style,
        className,
        name,
        label,
        labelClassName,
        errorClassName,
        restrictRule,
        disabled,
    };
    const control = { name, disabled, ...controlProps, ...rest };

    return { row, control };
}
